import React from 'react';
import { RoundedButton } from '../RoundedButton/RoundedButton';
import { Box, Container, makeStyles } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

const css = makeStyles(theme => ({
    suggestApi: {
        background: '#fafafa',
        textAlign: 'center',
        padding: theme.spacing(16, 0),
    },
    suggestApiButtons: {
        marginTop: theme.spacing(4),
    },
}));

interface ActionContainerProps {
    title: string;
    message: string | React.ReactNode;
    button: {
        linkTo: string;
        text: string;
    };
}

export const ActionContainer = ({ title, message, button }: ActionContainerProps): JSX.Element => {
    const classes = css();

    return (
        <div className={classes.suggestApi}>
            <Container maxWidth="md">
                <Box mb={2} fontWeight={500} fontSize={'28px'} color={'secondary.main'}>
                    {title}
                </Box>
                <Box fontWeight={300} fontSize={'20px'} color={'secondary.main'}>
                    {message}
                </Box>
                <div className={classes.suggestApiButtons}>
                    <RouterLink to={button.linkTo}>
                        <RoundedButton variant="contained" color="primary">
                            {button.text}
                        </RoundedButton>
                    </RouterLink>
                </div>
            </Container>
        </div>
    );
};
